module.exports = __webpack_public_path__ + "img/A0SMITH-icon.5a9c2a11.png";